'use client';

import { Box, Text } from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import { useIsDesktop } from '@/_hooks/useBreakpoint';
import CommentDesktop from './comment.desktop';
import CommentMobile from './comment.mobile';
import { useQuery } from '@tanstack/react-query';
import reviewService from '@/_service/review.service';
import { useTranslations } from 'next-intl';

const Comment = ({ id }: { id?: string }) => {
  const [isOpen, setOpen] = useState(false);

  const t = useTranslations();
  const isDesktop = useIsDesktop();

  const { data } = useQuery({
    queryKey: ['reviews', id],
    queryFn: () =>
      reviewService
        .getList({ related_subject: 'product', product_id: id })
        .then((res) => res?.data),
    enabled: Boolean(id),
  });

  const filteredReviews = useMemo(() => {
    return data?.reviews?.filter((el) => el.rating >= 4) || [];
  }, [data?.reviews]);

  return (
    <>
      <Box width='2px' height='13px' border-radius='1px' bg='#E0E8F199'></Box>
      {Number(data?.count || 0) ? (
        <Text
          color='primary'
          fontSize='xs'
          fontWeight={500}
          onClick={() => setOpen(true)}
        >
          {data?.count || 0} {t('reviews')}
        </Text>
      ) : (
        <Text opacity={0.2} fontWeight={500} fontSize='xs'>
          {t('no_reviews')}
        </Text>
      )}
      {isDesktop ? (
        <CommentDesktop
          open={isOpen}
          onClose={() => setOpen(false)}
          reviews={filteredReviews}
        />
      ) : (
        <CommentMobile
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          reviews={filteredReviews}
        />
      )}
    </>
  );
};

export default Comment;
